module.exports = __webpack_public_path__ + "static/media/daylytes_post.0ba57886.png";